import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=2ff0b22a&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=2ff0b22a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0b22a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff0b22a')) {
      api.createRecord('2ff0b22a', component.options)
    } else {
      api.reload('2ff0b22a', component.options)
    }
    module.hot.accept("./SocialMedia.vue?vue&type=template&id=2ff0b22a&scoped=true", function () {
      api.rerender('2ff0b22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/SocialMedia.vue"
export default component.exports